// extracted by mini-css-extract-plugin
module.exports = {"inputForm":"complaint_inputForm__Kz_wB","TextError":"complaint_TextError__3PgqO"};